import building from 'plugins/i18n/entity/building.de.ts'
import unit from 'plugins/i18n/entity/unit.de.ts'

const meter = {
	name: 'Zählerstände',
	icon: 'fas fa-tachometer-alt',
	fields: {
		hp_id: 'Zählernummer',
		device_type: {
			description: 'Art',
		},
		installation_place: 'Lage',
		removed_at: 'Ausgebaut am',
		last_accepted_level: {
			value: 'Letzter Wert',
			read_off_at: 'Datum letzter Wert',
		},
		building: {
			...building.fields,
		},
		unit: {
			...unit.fields,
		},
	},
}

export default meter
